import type { PaginatorDesignTokens, PaginatorTokenSections } from '@primeuix/themes/types/paginator';

export const root: PaginatorTokenSections.Root = {
    padding: '12px',
    gap: '4px',
    borderRadius: '{content.borderRadius}',
    background: '{content.background}',
    color: '{content.color}',
    transitionDuration: '{transitionDuration}'
};

export const navButton: PaginatorTokenSections.NavButton = {
    background: 'transparent',
    hoverBackground: '{content.hoverBackground}',
    selectedBackground: '{highlight.background}',
    color: '{text.mutedColor}',
    hoverColor: '{text.hoverColor}',
    selectedColor: '{highlight.color}',
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '{borderRadius.sm}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export const currentPageReport: PaginatorTokenSections.CurrentPageReport = {
    color: '{text.mutedColor}'
};

export const jumpToPageInput: PaginatorTokenSections.JumpToPageInput = {
    maxWidth: '2.5rem'
};

export default {
    root,
    navButton,
    currentPageReport,
    jumpToPageInput
} satisfies PaginatorDesignTokens;
